import { FeedbotThunk } from '../types'
import { modalsActions } from '../modals/modalsSlice'
import { doIHaveExclusiveUiOpenSelector } from './selectors'
import { reportClosingExclusiveUiToServer } from './socketServerConnectionService'

export const closeAllExclusiveUi = (): FeedbotThunk => (dispatch, getState) => {
  const isExclusiveUiOpen = doIHaveExclusiveUiOpenSelector(getState())

  if (!isExclusiveUiOpen) {
    return
  }

  reportClosingExclusiveUiToServer()
  dispatch(modalsActions.closeModal())
}
